import { collectionEngineV1 } from '../apis.js';
import { insightsQuery } from '../insights/filter-params.js';
const insightsV1API = collectionEngineV1('/insights');
export const getCaseFilterCount = (caseFilter) => insightsV1API('POST', '/count', {
    body: { caseFilter },
});
export const getAggregation = (type, caseFilter) => insightsV1API('POST', `/aggregations/${type}`, {
    body: { caseFilter },
});
export const getCaseFilterQueue = (caseFilter) => insightsV1API('POST', '/queue', {
    body: { caseFilter },
});
export const caseFilterBulk = (caseFilter, action, c) => insightsV1API('POST', `/bulk-action${c?.noConfirmationEmail ? '?noConfirmationEmail=true' : ''}`, {
    body: { caseFilter, action },
});
export const getBulkAction = (id) => insightsV1API('GET', `/bulk-actions/${id}`);
export const getDownload = (id) => insightsV1API('GET', `/downloads/${id}`);
export const getDownloads = () => insightsV1API('GET', '/downloads');
export const getDownloadUrl = (id) => insightsV1API('GET', `/downloads/${id}/url`);
export const getPaymentPlansInsights = (caseFilter, params) => insightsV1API('POST', `/payment-plans${insightsQuery({ base: params })}`, {
    body: { caseFilter },
});
export const getUpdatesInsights = (caseFilter, params) => insightsV1API('POST', `/updates${params.from || params.to ? '?' : ''}${params.from ? `from=${params.from}${params.to ? '&' : ''}` : ''}${params.to ? `to=${params.to}` : ''}`, {
    body: { caseFilter },
});
export const getInteractionsInsights = (caseFilter, params) => insightsV1API('POST', `/interactions${params.from || params.to ? '?' : ''}${params.from ? `from=${params.from}${params.to ? '&' : ''}` : ''}${params.to ? `to=${params.to}` : ''}`, {
    body: { caseFilter },
});
export const getEconomyInsights = (caseFilter, params) => insightsV1API('POST', `/economy${params.from || params.to ? '?' : ''}${params.from ? `from=${params.from}${params.to ? '&' : ''}` : ''}${params.to ? `to=${params.to}` : ''}`, {
    body: { caseFilter },
});
export const getCreditorWebDashboard = (creditorId) => insightsV1API('GET', `/creditor-web-dashboard?creditorId=${creditorId}`);
export const requestCaseOverviewReport = (creditorIds, lang, caseStates, to, includeDocuments, includeVouchers, includeRki, caseFilter) => insightsV1API('POST', '/reports/case-overview', {
    body: {
        lang,
        to,
        creditorIds,
        includeDocuments: !!includeDocuments,
        includeVouchers: !!includeVouchers,
        includeRki: !!includeRki,
        caseStates,
        caseFilter,
    },
});
export const requestPaymentPlanReport = (lang, creditorIds) => insightsV1API('POST', '/reports/payment-plans', {
    body: {
        lang,
        creditorIds,
    },
});
export const requestPhoneCallsReport = (lang, days) => insightsV1API('POST', `/reports/phone-calls?lang=${lang}&days=${days}`);
export const requestCreditorsReport = (lang) => insightsV1API('POST', `/reports/creditors?lang=${lang}}`);
export const requestInterestOverviewReportExcel = (creditorIds, lang) => insightsV1API('POST', '/reports/interest-overview/excel', {
    body: {
        lang,
        creditorIds,
    },
});
export const requestInterestOverviewReportXML = (creditorIds, lang, year, quarter, correctionNumber) => insightsV1API('POST', '/reports/interest-overview/xml', {
    body: {
        lang,
        creditorIds,
        year,
        quarter,
        correctionNumber,
    },
});
export const requestInteractionsReport = (from, to, lang) => insightsV1API('POST', `/reports/interactions?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}&lang=${encodeURIComponent(lang)}`);
//# sourceMappingURL=insights.js.map